module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-smile-gallery"
  }, [_c('div', {
    staticClass: "custom-smile-gallery__container"
  }, [_vm._l((_vm.props.images), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-smile-gallery__gallery--image",
      style: ({
        backgroundImage: 'url(' + item.image + ')'
      })
    })
  }), _c('div', {
    staticClass: "custom-smile-gallery__textbox"
  }, [_c('div', {
    staticClass: "custom-smile-gallery__title"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.textbox.title
    }
  })], 1), _c('div', {
    staticClass: "custom-smile-gallery__subtitle"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.textbox.subtitle
    }
  })], 1), _c('div', {
    staticClass: "custom-smile-gallery__body"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.textbox.body
    }
  })], 1), _c('div', {
    staticClass: "custom-smile-gallery__button"
  }, [_c('FunctionButton', {
    attrs: {
      "content": _vm.props.textbox.button,
      "function1": _vm.openModal
    }
  })], 1)]), _vm._l((_vm.props.images_bottom), function(item, i) {
    return _c('div', {
      key: i + 10,
      staticClass: "custom-smile-gallery__gallery--image-bottom",
      style: ({
        backgroundImage: 'url(' + item.image + ')'
      })
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa4f2a5e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-smile-gallery/custom-smile-gallery.pug
// module id = 612
// module chunks = 1